import { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import Loader from '../../Loader/Loader';

import { useStore } from '../../../hook-store/store';
import { 
  cardExpire,
  getCustomerCardPaymentMethods,
 } from '../../../utils/stripe/payment-method-utils';

 import { BACKEND_URL } from '../../../App'

 import './PaymentMethods.css';
// import classes from './PaymentMethods.module.css';

function GetCurrentSubscription(props) {
  const {
    subscriptionId,
    isSubscribe,
  } = props;
  
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    customerMethods,
    subscriptions,
    currentSubscription,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (customerMethods.length === 0) {
      getPaymentMethodsHandler();
    }
  },[subscriptions, currentSubscription]);

  useEffect(() => {
    if (subscriptions.length > 0) {
      setCurrentSubscriptionHandler(subscriptions);
    }
  },[subscriptions]);

  useEffect(() => {
    if (currentSubscription && customerMethods.length > 0) {
      setValidMethodHandler(currentSubscription);
    }
  },[currentSubscription, customerMethods, subscriptions]);

  const setCurrentSubscriptionHandler = (subscriptions) => {
    const currentSubscription = subscriptions.find(ele => {
      return ele.status === 'trialing' || ele.status === 'trialing' || ele.status === 'active';
    });

    if (currentSubscription) {
      dispatch('SET_CURRENTSUBSCRIPTION', currentSubscription);
    }

    // console.log('currentSubscription', currentSubscription);
  }

  const setValidMethodHandler = (currentSubscription) => {
    const defaultMethodId = currentSubscription.default_payment_method;

    const defaultMethod = customerMethods.find(method => {
      return method.id === defaultMethodId;
    });

    if (defaultMethod) {
      const cardExpired = cardExpire(
        defaultMethod.card.exp_month, 
        defaultMethod.card.exp_year
      );

      if (!cardExpired) {
        dispatch('SET_VALIDSUBSCRIPTIONMETHOD', defaultMethod);
      }
    }
  };

  const getPaymentMethodsHandler = async () => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await getCustomerCardPaymentMethods(
        BACKEND_URL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
      );

      // console.log();

      if (resData.data) {
        const kuraList = resData.data.filter(method => {
          return method.metadata && method.metadata.kuraStorageServices;
        });

        // console.log(kuraList);

        dispatch('SET_CUSTOMERMETHODS', kuraList);

        // setDefaultMethod(methodList);

      }
      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };

 

  return (
    <Fragment>
    </Fragment>
  );
}

export default GetCurrentSubscription;
